import { useEffect, useRef, useState } from 'react';

const useStopwatch = (isReading: boolean, initialValue?: number) => {
  const [elapsedTime, setElapsedTime] = useState<number>(initialValue ?? 0);
  const countRef = useRef<number | null>(null);

  const startTimer = () => {
    const startTime = Date.now() - elapsedTime;
    countRef.current = window.setInterval(() => {
      setElapsedTime(Math.round((Date.now() - startTime) / 1000));
    }, 1000) as unknown as number;
  };

  const pauseTimer = () => {
    if (countRef.current !== null) {
      clearInterval(countRef.current);
      countRef.current = null;
    }
  };

  useEffect(() => {
    if (isReading) {
      startTimer();
    } else {
      pauseTimer();
    }

    return pauseTimer;
    // eslint-disable-next-line
  }, [isReading]);

  return elapsedTime;
};

export default useStopwatch;
